import { AppService } from '@/models/app-service'

export class CompanyDetails{
  services?: AppService[]
  archived?: boolean

  constructor(params?: Partial<CompanyDetails>) {
    Object.assign(this, params)
  }
}
